import { render, staticRenderFns } from "./Pointshop-code-insert.vue?vue&type=template&id=2f612cb1&scoped=true&"
import script from "./Pointshop-code-insert.vue?vue&type=script&lang=js&"
export * from "./Pointshop-code-insert.vue?vue&type=script&lang=js&"
import style0 from "./Pointshop-code-insert.vue?vue&type=style&index=0&id=2f612cb1&scoped=true&lang=scss&"
import style1 from "./Pointshop-code-insert.vue?vue&type=style&index=1&id=2f612cb1&lang=scss&"


/* normalize component */
import normalizer from "!../../integrationtest/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f612cb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f612cb1')) {
      api.createRecord('2f612cb1', component.options)
    } else {
      api.reload('2f612cb1', component.options)
    }
    module.hot.accept("./Pointshop-code-insert.vue?vue&type=template&id=2f612cb1&scoped=true&", function () {
      api.rerender('2f612cb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pointshop-widget/src/Pointshop-code-insert.vue"
export default component.exports